"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getColorByScore = function (score) {
    if (score === undefined) {
        return '#9BA0FB';
    }
    if (score >= 75) {
        return '#32A26C';
    }
    if (score >= 50) {
        return '#FCD851';
    }
    if (score >= 25) {
        return '#FC9963';
    }
    return '#FC4F78';
};
exports.default = getColorByScore;
